import { Route, Switch } from 'react-router';

import EditGoal from './EditGoal';
import Goal from './Goal';
import GoalRevision from './GoalRevision';
import OrganizationGoals from './OrganizationGoals';
import UserGoals from './UserGoals';
import PersonalGoals from './ViewerGoals';
import CollectiveGoals from './collective-goals/CollectiveGoals';

export default function Goals() {
	return (
		<Switch>
			<Route path={[`/goals`, `/goals/competencies`]} exact>
				{({ match }) => match && <PersonalGoals />}
			</Route>
			<Route path="/goals/organization" exact>
				{({ match }) => match && <OrganizationGoals />}
			</Route>
			<Route path="/goals/collective" exact>
				{({ match }) => match && <CollectiveGoals />}
			</Route>
			<Route path="/goals/collective/:id" exact>
				{({ match }) => match && <CollectiveGoals />}
			</Route>
			<Route path={['/users/:id/goals', '/users/:id/goals']} exact>
				{({ match }) => match && <UserGoals userID={match.params.id} />}
			</Route>
			<Route
				path={[
					`/goals/new`,
					`/users/:id/goals/new`,
					`/goals/:goalID/edit`,
					`/users/:id/goals/:goalID/edit`,
				]}
				exact
			>
				{({ match }) =>
					match && (
						<EditGoal
							userID={'id' in match.params ? match.params.id : undefined}
							goalID={'goalID' in match.params ? match.params.goalID : undefined}
						/>
					)
				}
			</Route>
			<Route
				path={[`/goals/:goalID`, `/users/:id/goals/:goalID`, `/users/:id/goals/:goalID`]}
				exact
			>
				{({ match }) =>
					match && (
						<Goal
							userID={'id' in match.params ? match.params.id : undefined}
							goalID={match.params.goalID}
						/>
					)
				}
			</Route>
			<Route
				path={[
					`/goals/:goalID/revisions/:revision`,
					`/users/:id/goals/:goalID/revisions/:revision`,
				]}
				exact
			>
				{({ match }) =>
					match && (
						<GoalRevision
							userID={'id' in match.params ? match.params.id : undefined}
							goalID={match.params.goalID}
							revision={match.params.revision}
						/>
					)
				}
			</Route>
			<Route
				path={[
					`/goals/:goalID/revisions/:revision/:secret`,
					`/users/:id/goals/:goalID/revisions/:revision/:secret`,
				]}
				exact
			>
				{({ match }) =>
					match && (
						<GoalRevision
							userID={'id' in match.params ? match.params.id : undefined}
							goalID={match.params.goalID}
							revision={match.params.revision}
							secret={match.params.secret}
						/>
					)
				}
			</Route>
		</Switch>
	);
}
